import { Outlet } from "react-router-dom"

const VisitaModule = () => {
  return <Outlet/>
}
export default VisitaModule